import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { BackOfficeSession } from 'src/app/Services/Api.BackOfficeSession/BackOfficeSession';
import { MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource } from '@angular/material';
import { OpenModal } from 'src/app/OpenModal';
import { BilleteraService } from 'src/app/Services/Api.Billetera/BilleteraService';

@Component({
  selector: 'app-cambiar-permisos',
  templateUrl: './cambiar-permisos.component.html',
  styleUrls: ['./cambiar-permisos.component.css']
})
export class CambiarPermisosComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = [ "activo"];
  acciones: any[] = [];
  ordenado = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  Loading = true;

  constructor(private _Billetera: BilleteraService, public dialogRef: MatDialogRef<CambiarPermisosComponent>, private OModal: OpenModal, @Inject(MAT_DIALOG_DATA) public data: number, private changeDetectorRefs: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.cargarMenus();
  }

  ngAfterViewInit() {
  }

  construirObjeto() {
    this._Billetera.obtenerPermisos(this.data).subscribe((res) => {
      const record = (res as any).recordset;
      if (record != null) {
        record.forEach((element) => {
          this.acciones.forEach((elm) => {
            if (elm.accionID == element.accionID) {
              elm.activo = element.activo;
            }
          })
          this.Loading = false;
        });
      }
    })
    this.acciones.forEach(element => {
      element.hijos = this.acciones.filter(x => x.accionPadreID == element.accionID)
    });
    this.dataSource.data = this.acciones.filter(x => x.accionPadreID == 0)
  }

  cargarMenus() {
    this._Billetera.obtenerAcciones().subscribe(
      (res) => {
        const record = (res as any).recordset;
        if (record != null) {
          this.acciones = record;
        }
        this.dataSource.paginator = this.paginator;
        this.Loading = false;
        this.construirObjeto();
      }
    )
  }

  cambiarPermisos() {
    this.ordenado = this.dataSource.data;
    this.dataSource.data.forEach(x => {
      x.hijos.forEach(element => {
        this.ordenado.push(element);
      });
      delete x.hijos;
    })
    this.ordenado.forEach(x => {
      x.perfilID = this.data;
      this._Billetera.cambiarPermiso(x).subscribe(res => {
        const record = (res as any).error;
        if (record) {
          console.error(record)
        }
      })
    })
    this.dialogRef.close()
  }

  updateRoot(element){
    if(!element.activo){
      element.hijos.forEach(x => {
        x.activo = false;
      });
    }
    else{
      element.hijos.forEach(x => {
        x.activo = true;
      });
    }
  }

  updateAllComplete(element) {
    if (!element.activo && element.hijos.filter(x => x.activo) != []) {
      element.activo = true;
      return;
    }
    var hijos = false;
    element.hijos.forEach(x => hijos = hijos || x.activo);
    if (element.activo && !hijos) {
      element.activo = false;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onCancelar() {
    this.dialogRef.close();
  }

}

